import { Injectable } from "@angular/core";

import { ToastController } from "@ionic/angular";

export interface ModalOptions {
  content: any; //组件
  model?: ""; //multiple
  title?: string; //标题
}
@Injectable()
export class KreFormIonToastService {
  constructor(protected toastCtrl: ToastController) {}

  /**
   * 弹出信息
   *
   * @param: {string} message     信息提示
   * @param:  {string} [position]  位置
   * @param: {number} [duration]  持续事件
   */
  async presentToast(
    msg: string,
    position?: "top" | "bottom" | "middle",
    duration?: number
  ) {
    position = position || "bottom";
    duration = duration || 1500;
    const toast = await this.toastCtrl.create({
      color: "dark",
      message: msg,
      position,
      duration,
      animated: true,
    });
    toast.present();
  }
}
